export const ticariKurumsalPage = () => `
  <section class="page-content service-page">
    <div class="container">
      <div class="service-header">
        <h1 class="page-title">Ticari ve Kurumsal Sigortalar</h1>
        <p class="page-subtitle">İşletmenizi ve ticari faaliyetlerinizi kapsamlı sigorta çözümleri ile güvence altına alıyoruz.</p>
      </div>

      <div class="service-list">
        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
          </div>
          <div class="service-info">
            <h3>Nakliyat Sigortası</h3>
            <p>Taşınan mallarınızı kara, deniz ve hava yoluyla nakliye sırasında oluşabilecek hasar, kayıp ve çalınma risklerine karşı koruma altına alır.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
          </div>
          <div class="service-info">
            <h3>Sorumluluk Sigortaları</h3>
            <p>İşletmenizin üçüncü kişilere vereceği maddi ve bedeni zararlardan doğan hukuki sorumluluklarınızı karşılar. İşveren sorumluluk sigortası da bu kapsamdadır.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line></svg>
          </div>
          <div class="service-info">
            <h3>Mesleki Sorumluluk Sigortası</h3>
            <p>Doktor, avukat, mühendis, mali müşavir gibi meslek sahiplerinin mesleki faaliyetleri sırasında verebilecekleri zararlara karşı teminat sağlar.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
          </div>
          <div class="service-info">
            <h3>Emtia Sigortası</h3>
            <p>Depolarda veya transit halindeki ticari mallarınızı yangın, su baskını, hırsızlık ve diğer risklere karşı güvence altına alır.</p>
          </div>
        </div>
      </div>

      <div class="service-cta">
        <h2>İşletmeniz İçin Teklif Alın</h2>
        <p>Ticari ve kurumsal sigorta ihtiyaçlarınız için özel çözümler sunuyoruz.</p>
        <a href="/teklif-al" class="btn-primary">Hemen Teklif Al</a>
      </div>
    </div>
  </section>
`;
